import { Helmet } from "react-helmet";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import PageGallery from "components/pagegallery";
import collectionMeta from "content/collections/papuan-carpet-python.json";
import { animalGridFromJson } from "hooks/useGallery";
// Dr Pepper
// Mello Yello

const animalGridData = animalGridFromJson(collectionMeta);

const PapuanCarpetPython = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Papuan Carpet Pythons (Morelia spilota variegata)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/papuan-carpet-python" />
      </Helmet>
      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />
      <AnimalGrid data={animalGridData} />
      <BodyText>
        My Papuan carpet pythons come from Inland Reptiles and are a pretty
        recent addition for me, even though I've seen wild-caught Papuans
        available from importers for decades. They are frequently overlooked,
        but incredible to look at. Mine stay perched on their branches nearly
        full-time.
      </BodyText>
      <PageGallery slug="papuan-carpet-python" maxWidth="900" />
    </ContentBox>
  );
};

export default PapuanCarpetPython;
